import React, { createContext, useState } from 'react';

import { IBreadcrumbs } from '@mais-retorno-front/models/breadcrumbs.model';

import { IBreadcrumbsContext } from './model';

export const BreadcrumbsContext = createContext<IBreadcrumbsContext>({
  breadcrumbs: null,
  setBreadcrumbs: null,
});

export const BreadcrumbsProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumbs[]>([]);

  return (
    <BreadcrumbsContext.Provider
      value={{
        breadcrumbs,
        setBreadcrumbs,
      }}
    >
      {children}
    </BreadcrumbsContext.Provider>
  );
};
